<template>
  <div class="container career-item">
    <div class="careers-loop-item">
      <div class="row">
        <div class="col-md-4">
          <h5><a v-bind:href="data.url">{{data.title}}</a></h5>
          <div class="small">{{data.department}}<span class="show-tablet in">,&nbsp;{{data.city}}</span></div>
        </div>
        <div class="col-md-2 offset-1 small">
          <div class="city show-desktop">{{data.city}}</div>
        </div>
        <div class="col-md-4">
          <div class="tags">
            <span class="capsule" v-bind:key="index" v-for="(cat, index) in data.tags">{{cat}}</span>
          </div>
        </div>
        <div class="col-md-1 text-right flex v-center"><a class="stick-right " v-bind:href="data.url"><svg><use xlink:href="#arrow-right"></use></svg></a></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CareersItem',
  props: {
    data: Object
  },
  methods: {}
}
</script>